import { render, staticRenderFns } from "./overallData.vue?vue&type=template&id=5c438184&scoped=true&"
import script from "./overallData.vue?vue&type=script&lang=js&"
export * from "./overallData.vue?vue&type=script&lang=js&"
import style0 from "./overallData.vue?vue&type=style&index=0&id=5c438184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c438184",
  null
  
)

export default component.exports